export const aboutme1 = `As a CS undergrad, I intend to push my limits and make use of my 
abilities to the fullest to help achieve my short and long term goals. I believe in widening ones’ skill tree,
 thus I am excited to keep learning about new technologies.`;

export const aboutme2 = `So far in my journey, I have delved into a lot of key areas of CS whilst
 learning a lot of things along the way. I have taken part in many contest that have helped me immensely in
  understanding where I lack and what new skills and technologies I need to learn and what the best practices are,
   in the industry.`;

export const aboutme3 = `I strongly believe that good communication and leadership lead to great results and
 I have been fortunate to have successfully led teams in curriculum projects and other non-technical events.
I consider myself creative and hardworking, as my stats show. If you liked my profile so far, drop me a message and we'll discuss how I can be useful to your project.`;